import React, { useState } from "react";
import Header from "../header/Header";
import BreadCrumb from "../global/breadcrumbs/BreadCrumb";
import DropDown from "../global/fields/CourseDropDownId";
import { apirequest } from "../../API/api";
import { endpoint } from "../../API/config";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import WhiteSpace from "../global/regEx/WhiteSpaceValidator";

const AddSection = () => {

  let history = useHistory();
  const login_Details = useSelector(state=>state?.loginData?.LoginDetails);
  const [sectionName, setSectionName] = useState("");
  const [salesforceId, setSalesforceId] = useState("");
  const [courseTags, setCourseTags] = useState([]);
  const [showLabel, setShowLabel] = useState([]);
  const [showLabelwithId,setShowLabelwithId]=useState([]);
  const [courses, setCourses] = useState("");
  const [courseId, setCourseId] = useState([]);

  const { data: getCourseData} = useQuery(`${endpoint.course_data.key}`, () =>
    apirequest({
      url: `${endpoint.course_data.addr}`,
      method : "post",
      data : {
        "adminimspin":login_Details.userImsPin
      }
    }));
  const fetchAddSection = () => {
    return apirequest({
      url: `${endpoint.add_section.addr}`,
      method: "post",
      data: {
        sectionName: sectionName,
        isActive: "1",
        courseId: showLabelwithId.map(x=>x.courseId),
        createdBy: login_Details.userImsPin,
        sfId:salesforceId,
      },
    });
  };

  //API request to add new sections data
  const { refetch: addProductGroupRefetch } = useQuery(
    endpoint.add_section.key,
    fetchAddSection,
    {
      enabled: false,
      onSuccess :(res)=>{alert(res.data.message),window.location.reload(false);},
      retry: 0,
      onError:(err)=>{
        alert(err.data.message);
      }
    },
  );
  const onsave = e => {
    if(WhiteSpace(sectionName) || WhiteSpace(salesforceId)){
      alert("Please enter valid Section Name and Sales Force Id");
    }
    else if(showLabelwithId.length===0){
      alert("Please Select Course");
    }
    else{
      addProductGroupRefetch();
    }
    e.preventDefault();
  };

  return (
    <div className="flex flex-col ">
      <Header />
      <BreadCrumb />
      <div className="mt-2 mx-12  px-8 py-2  ">
        <form
          className=" flex flex-col h-80 relative bg-secondary-100 py-6 shadow-outer"
          onSubmit={onsave}>
          <div className="h-full space-y-6  px-12 py-6 relative">
            
            <div className="flex  justify-between py-5">
              <label className=" font-normal text-lg font-ibm ">
                Section Names
                <input
                  required
                  type="text"
                  name="blogName"
                  className="border-2 h-10 border-secondary-300 absolute left-48 w-2/5 rounded-lg focus:outline-none"
                  value={sectionName}
                  onChange={e => setSectionName(e.target.value)}
                />
              </label>
            </div>
            <div className="flex py-2 space-x-3">
              <label className=" font-normal text-lg font-ibm ">
                Course Name
              </label>
              {/* {isSuccess && */}
              <DropDown
                placeholder={"Search Course(s)"}
                options={getCourseData?.data?.data?.courseList}
                setUpdatedOptions={setCourseTags}
                type={"multiselect"}
                width={"w-[30rem]"}
                courseTags={courseTags}
                showLabel={showLabel}
                setShowLabel={setShowLabel}
                value={courses}
                setValue={setCourses}
                courseId={courseId}
                setCourseId={setCourseId}
                showLabelwithId={showLabelwithId}
                setShowLabelwithId={setShowLabelwithId}
              />
            </div>
            <div className="flex  justify-between py-2">
              <label className=" font-normal text-lg font-ibm ">
              Sales Force ID
                <input
                  required
                  type="text"
                  name="salesForce"
                  className="border-2 h-10 border-secondary-300 absolute left-48 w-2/5 rounded-lg focus:outline-none"
                  value={salesforceId}
                  onChange={e => setSalesforceId(e.target.value)}
                />
              </label>
            </div>
          </div>
          <div className="flex items-center justify-center mt-7 pr-20">
            <button className="bg-primary-200 text-white font-ibm px-12 rounded-xl hover:opacity-75 shadow-outer py-[10px] text-base font-medium mr-10 cursor-pointer">
              SAVE
            </button>
            <p onClick={history.goBack} className=" text-black boxShadow-forButton font-ibm px-10 rounded-xl hover:opacity-75 shadow-outer text-base font-medium py-[10px] cursor-pointer">
              EXIT
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSection;
